import { AfterViewInit, ElementRef, EventEmitter, OnChanges, OnDestroy } from '@angular/core';
import { ControlValueAccessor, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { bindFunctionsToThis, isNullOrUndefined } from '../../extensions';
var SelectComponent = /** @class */ (function () {
    function SelectComponent(formBuilder) {
        this.formBuilder = formBuilder;
        this.isShowing = false;
        this.place = 'bottom';
        this.align = 'left';
        this.icon = 'expand_more';
        // @Input() public items: {
        //     text: string,
        //     value: string,
        //     selected: boolean,
        //     hide: boolean
        // }[];
        this.itemSelected = new EventEmitter();
        this.onOpen = new EventEmitter();
        bindFunctionsToThis(this);
        this.formGroup = this.formBuilder.group({
            'input': [null, [Validators.required]],
        });
    }
    SelectComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        setTimeout(function () {
            _this.bindEvents();
            _this.value = _this.value.filter(function (x) { return isNullOrUndefined(x.hide) || x.hide === false; });
            var selected = _this.value.first(function (x) { return x.selected; });
            if (selected) {
                _this.fieldValue = selected.text;
            }
        }, 500);
    };
    Object.defineProperty(SelectComponent.prototype, "value", {
        get: function () {
            return this._value ? this._value.filter(function (x) { return !!x; }) : undefined;
        },
        set: function (newValue) {
            if (newValue === this._value || (isNullOrUndefined(this._value) && isNullOrUndefined(newValue))) {
                return;
            }
            this._value = newValue;
            if (this._notifyChange) {
                this._notifyChange(newValue);
            }
        },
        enumerable: true,
        configurable: true
    });
    SelectComponent.prototype.writeValue = function (newValue) {
        this._value = newValue;
    };
    SelectComponent.prototype.registerOnChange = function (fn) {
        this._notifyChange = fn;
    };
    SelectComponent.prototype.registerOnTouched = function (fn) {
    };
    SelectComponent.prototype.ngOnDestroy = function () {
        this.unbindEvents();
    };
    SelectComponent.prototype.setSelected = function (value) {
        var selected = this.value.first(function (x) { return x.value === value; });
        if (selected) {
            this.value.forEach(function (x) { return x.selected = false; });
            selected.selected = true;
            this.fieldValue = selected.text;
        }
    };
    SelectComponent.prototype.select = function (value) {
        var _this = this;
        this.itemSelected.emit(value);
        this.fieldValue = value.text;
        this.trigger.input.nativeElement.focus();
        setTimeout(function () {
            _this.close();
        });
    };
    SelectComponent.prototype.bindEvents = function () {
        window.addEventListener('click', this.close);
        this.trigger.input.nativeElement.addEventListener('click', this.show);
    };
    SelectComponent.prototype.unbindEvents = function () {
        window.removeEventListener('click', this.close);
        this.trigger.input.nativeElement.removeEventListener('click', this.show);
    };
    SelectComponent.prototype.close = function (event) {
        if (!event) {
            this.isShowing = false;
            return;
        }
        var parentNode = event.target.parentNode;
        while (parentNode != null && parentNode !== this.container.nativeElement) {
            parentNode = parentNode.parentNode;
        }
        this.isShowing = (parentNode === this.container.nativeElement) || event.target.textContent === 'expand_more';
    };
    SelectComponent.prototype.show = function (event) {
        if (this.disabled) {
            return;
        }
        if (this.showDropDownItem === 'false') {
            this.itemSelected.emit();
            return;
        }
        this.onOpen.emit();
        event && event.stopPropagation();
        var dropDownGap = this.label ? 18 : 10;
        var container = this.container.nativeElement;
        var containerRect = container.getBoundingClientRect();
        var triggerRect = this.trigger.input.nativeElement.getBoundingClientRect();
        var top = triggerRect.height + dropDownGap;
        var left = 0;
        if (this.place === 'top') {
            top = -containerRect.height - dropDownGap;
        }
        if (this.align === 'right') {
            left = triggerRect.right - containerRect.width;
        }
        this.isShowing = true;
        container.style.left = left + "px";
        container.style.top = top + "px";
    };
    return SelectComponent;
}());
export { SelectComponent };



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/common/components/select/select.component.ts.pre-build-optimizer.js